import React, { useState, useEffect } from 'react';

interface RespawnTimerProps {
  deathTimestamp: string | null;
  respawnDurationHours?: number; // Optional: default to 1 hour
}

const RespawnTimer: React.FC<RespawnTimerProps> = ({ deathTimestamp, respawnDurationHours = 1 }) => {
  const [remainingTime, setRemainingTime] = useState<string>('');

  useEffect(() => {
    if (!deathTimestamp) {
      setRemainingTime('');
      return;
    }

    const calculateRemaining = () => {
      const deathTime = new Date(deathTimestamp).getTime();
      const respawnTime = deathTime + respawnDurationHours * 60 * 60 * 1000;
      const now = Date.now();
      const diff = respawnTime - now;

      if (diff <= 0) {
        setRemainingTime('Respawning soon...');
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setRemainingTime(
        `${hours.toString().padStart(2, '0')}:` +
        `${minutes.toString().padStart(2, '0')}:` +
        `${seconds.toString().padStart(2, '0')}`
      );
    };

    // Initial calculation
    calculateRemaining();

    // Update every second
    const intervalId = setInterval(calculateRemaining, 1000);

    // Cleanup interval on component unmount or when deathTimestamp changes
    return () => clearInterval(intervalId);

  }, [deathTimestamp, respawnDurationHours]);

  if (!deathTimestamp) {
    return null; // Don't render if not dead
  }

  return (
    <div className="text-center mt-4">
      <p className="text-lg font-semibold text-red-400">Dragon is resting...</p>
      <p className="text-sm text-gray-400">Respawn in: {remainingTime}</p>
    </div>
  );
};

export default RespawnTimer; 